import React from "react";
import { Modal, Text } from "@mantine/core";
import moment from "moment";
import DateRangePicker from "./DateRangePicker";
import { startOfWeek, addDays } from "./scheduleUtils";

// Lets the user pick the time period for an export, then confirms. Uses the
// Scheduler's own date-range picker design. `target` = { kind, format }.
export default function ExportPeriodModal({ opened, target, defaultStart, onConfirm, onClose }) {
  if (!target) return null;

  const kindLabel = target.kind === "evv" ? "EVV records" : target.kind === "schedule" ? "Schedule" : "Timesheets";
  const label = `${kindLabel} · ${String(target.format || "").toUpperCase()}`;
  const wkStart = startOfWeek(new Date(defaultStart || new Date()));
  // Schedules are often future-dated, so don't cap at today for a schedule
  // export; timesheets/EVV are historical, so they stay capped at today.
  const maxDate = target.kind === "schedule" ? undefined : new Date();

  const confirm = ([start, end]) =>
    onConfirm([moment(start).startOf("day"), moment(end).endOf("day")]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={700} color="var(--app-text)">{`Export ${label}`}</Text>}
      centered
      radius={14}
      size="auto"
      padding={20}
      zIndex={500}
      overlayProps={{ opacity: 0.45, blur: 1 }}
    >
      <Text fz={13} color="dimmed" mb={12}>Choose the time period to export.</Text>
      <DateRangePicker
        initialStart={wkStart}
        initialEnd={addDays(wkStart, 6)}
        maxDate={maxDate}
        applyLabel="Export"
        onApply={confirm}
        onCancel={onClose}
      />
    </Modal>
  );
}
